const state = {
  currentAppInfo: ''
}

const mutations = {
  CHANGE_CURRENT_APP_INFO (state, val) {
    state.currentAppInfo = val
  }
}

const actions = {

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
